import { NumericInputBase } from './NumericInputBase'
import type { FieldInputProps } from '../types'

/** EDIT-mode dla FieldType=NUMBER. PL format bez sufiksu, dowolna liczba miejsc. */
export function NumberInput({ field, value, onChange, disabled }: FieldInputProps) {
  return (
    <NumericInputBase
      id={`field-${field.fieldCode}`}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  )
}
